import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useOrganization } from "../context/OrganizationContext";

function FullScreenLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-sm text-slate-500">Loading…</p>
    </div>
  );
}

/** Requires a logged-in user only (used for the organization picker). */
export function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

/** Requires a logged-in user AND a chosen organization (used for the dashboard). */
export default function ProtectedRoute() {
  const { user, loading: authLoading } = useAuth();
  const { activeOrg, loading: orgLoading } = useOrganization();
  if (authLoading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (orgLoading) return <FullScreenLoader />;
  if (!activeOrg) return <Navigate to="/select-organization" replace />;
  return <Outlet />;
}
